import React from 'react';
import { Online, Offline } from './OnlineOffline';
import PendingCounter from './PendingCounter';

const NetworkStatusIndicator = props => {
  return (
    <div className="network-status-indicator">
      <Online>
        <div className={`network-status online ${props.synching ? "pulsating" : ""}`} />
        <PendingCounter className="on" {...props} />
      </Online>
      <Offline>
        <div className="network-status offline" />
        <PendingCounter className="off" {...props} />
      </Offline>
    </div>
  );
};

export default NetworkStatusIndicator;
